import * as React from "react"
const SvgComponent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={(props.width || 264)}
    height={(props.width|| 301)}
    viewBox="0 0 264 301"
    fill="none"
    {...props}
  >
    <path stroke="url(#avd)" strokeWidth={2} d="M262.501 1.138 1.001 299.579" />
    <defs>
      <linearGradient
        id="avd"
        x1={263}
        x2={-9}
        y1={11}
        y2={309}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#BEA56C" />
        <stop offset={1} stopColor="#BEA56C" stopOpacity={0.5} />
      </linearGradient>
    </defs>
  </svg>
)
export default SvgComponent
